import React, { useState, useEffect } from 'react';
import { Plus, List, Edit2, Trash2 } from 'lucide-react';
import { getAllExpenseSubCategory, saveExpenseSubCategory, deleteExpenseSubCategoryById, getAllExpenseCategory } from '../../../targetactioncreator';
import moment from 'moment';

function TAB2({ dateFilter }) {
  const [showAddForm, setShowAddForm] = useState(false);
  const [showList, setShowList] = useState(true);
  const [editingItem, setEditingItem] = useState(null);
  const [subcategories, setSubcategories] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);

  // Load categories and subcategories from API on component mount and when date filter changes
  useEffect(() => {
    loadCategories();
    loadSubcategories();
  }, [dateFilter]);

  const loadCategories = () => {
    getAllExpenseCategory('notRequired', '', '', (response) => {
      if (response && response.data) {
        setCategories(response.data);
      }
    }, (error) => {
      console.error('Error loading categories:', error);
    });
  };

  const loadSubcategories = () => {
    setLoading(true);
    
    if (dateFilter && dateFilter.active) {
      // Convert dates from YYYY-MM-DD to DD-MM-YYYY format for API
      const fromDate = dateFilter.fromDate ? moment(dateFilter.fromDate).format('DD-MM-YYYY') : '';
      const toDate = dateFilter.toDate ? moment(dateFilter.toDate).format('DD-MM-YYYY') : '';
      
      console.log('Loading subcategories with dates:', { fromDate, toDate });
      
      // Load subcategories with date filter
      getAllExpenseSubCategory('dateRequired', fromDate, toDate, '', (response) => {
        if (response && response.data) {
          setSubcategories(response.data);
          console.log('Subcategories loaded with filter:', response.data);
        }
        setLoading(false);
      }, (error) => {
        console.error('Error loading subcategories:', error);
        setLoading(false);
      });
    } else {
      // Load subcategories without date filter
      getAllExpenseSubCategory('notRequired', '', '', '', (response) => {
        if (response && response.data) {
          setSubcategories(response.data);
          console.log('Subcategories loaded without filter:', response.data);
        }
        setLoading(false);
      }, (error) => {
        console.error('Error loading subcategories:', error);
        setLoading(false);
      });
    }
  };
  const [formData, setFormData] = useState({
    category: '',
    categoryName: '',
    categoryType: '',
    categoryDescription: ''
  });
  const [errors, setErrors] = useState({});

  const handleAddClick = () => {
    setShowAddForm(true);
    setShowList(false);
    setEditingItem(null);
    setFormData({ category: '', categoryName: '', categoryType: '', categoryDescription: '' });
    setErrors({});
  };

  const handleListClick = () => {
    setShowList(true);
    setShowAddForm(false);
    setEditingItem(null);
  };

  const handleCloseForm = () => {
    setShowAddForm(false);
    setEditingItem(null);
    setFormData({ category: '', categoryName: '', categoryType: '', categoryDescription: '' });
    setErrors({});
  };

  const handleEditClick = (subcategory) => {
    setEditingItem(subcategory);
    setFormData({
      category: subcategory.categoryId,
      categoryName: subcategory.subCategoryName,
      categoryType: subcategory.subCategoryType,
      categoryDescription: subcategory.subCategoryDescription
    });
    setShowAddForm(true);
    setShowList(false);
    setErrors({});
  };

  const handleDeleteClick = (subcategoryId) => {
    if (window.confirm('Are you sure you want to delete this sub-category?\n\nThis action cannot be undone.')) {
      deleteExpenseSubCategoryById(subcategoryId, (response) => {
        console.log('Sub-category deleted successfully:', response);
        loadSubcategories(); // Reload the list
      }, (error) => {
        console.error('Error deleting sub-category:', error);
        alert('Error deleting sub-category. Please try again.');
      });
    }
  };

  const handleInputChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
    if (errors[field]) {
      setErrors(prev => ({ ...prev, [field]: '' }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.category.trim()) {
      newErrors.category = 'Category is mandatory';
    }
    if (!formData.categoryName.trim()) {
      newErrors.categoryName = 'Sub Category Name is mandatory';
    }
    if (!formData.categoryType.trim()) {
      newErrors.categoryType = 'Sub Category Type is mandatory';
    }
    if (!formData.categoryDescription.trim()) {
      newErrors.categoryDescription = 'Category Sub Description is mandatory';
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSaveData = () => {
    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    const subcategoryData = {
      categoryId: formData.category,
      subCategoryName: formData.categoryName,
      subCategoryType: formData.categoryType,
      subCategoryDescription: formData.categoryDescription
    };

    if (editingItem) {
      // Update existing subcategory (you may need to add update API)
      subcategoryData.subCategoryId = editingItem.id;
    }

    saveExpenseSubCategory(subcategoryData, (response) => {
      console.log('Sub-category saved successfully:', response);
      loadSubcategories(); // Reload the list
      handleCloseForm();
    }, (error) => {
      console.error('Error saving sub-category:', error);
      alert('Error saving sub-category. Please try again.');
    });
  };

  return (
    <div style={{ textAlign: "center" }}>
      {/* Left Side Tabs */}
      <div style={{ 
        display: "flex", 
        flexDirection: "row", 
        alignItems: "center", 
        marginBottom: "32px",
        gap: "8px",
        flexWrap: "wrap"
      }}>
        <div style={{
          display: "flex",
          alignItems: "center",
          gap: "4px",
          padding: "4px 8px",
          background: "#f8fafc",
          borderRadius: "4px",
          border: "1px solid #e2e8f0",
          cursor: "pointer",
          transition: "all 0.2s ease"
        }} onClick={handleAddClick}>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-square-plus-icon lucide-square-plus" style={{ color: "#015c57" }}>
            <rect width="18" height="18" x="3" y="3" rx="2"/>
            <path d="M8 12h8"/>
            <path d="M12 8v8"/>
          </svg>
          <span style={{ 
            fontSize: "11px", 
            fontWeight: "600", 
            color: "#015c57" 
          }}>
            ADD
          </span>
        </div>

        <div style={{
          display: "flex",
          alignItems: "center",
          gap: "4px",
          padding: "4px 8px",
          background: "#f8fafc",
          borderRadius: "4px",
          border: "1px solid #e2e8f0",
          cursor: "pointer",
          transition: "all 0.2s ease"
        }} onClick={handleListClick}>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-list-check-icon lucide-list-check" style={{ color: "#015c57" }}>
            <path d="M16 5H3"/>
            <path d="M16 12H3"/>
            <path d="M11 19H3"/>
            <path d="m15 18 2 2 4-4"/>
          </svg>
          <span style={{ 
            fontSize: "11px", 
            fontWeight: "600", 
            color: "#015c57" 
          }}>
            LIST
          </span>
        </div>
      </div>

      {/* Add/Edit Sub-Category Form - Integrated Non-Modal */}
      {showAddForm && (
        <div style={{
          backgroundColor: "#f8fafc",
          border: "1px solid #e2e8f0",
          borderRadius: "12px",
          padding: "24px",
          marginBottom: "32px",
          width: "100%",
          maxWidth: "1200px",
          margin: "0 auto 32px auto"
        }}>
          {/* Form Header */}
          <div style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "20px",
            paddingBottom: "16px",
            borderBottom: "1px solid #e2e8f0"
          }}>
            <div style={{
              display: "flex",
              alignItems: "center",
              gap: "12px"
            }}>
              <div style={{
                width: "40px",
                height: "40px",
                borderRadius: "8px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "#015c57",
                color: "#ffffff"
              }}>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <rect width="18" height="18" x="3" y="3" rx="2"/>
                  <path d="M8 12h8"/>
                  <path d="M12 8v8"/>
                </svg>
              </div>
              <div style={{ textAlign: "left" }}>
                <h3 style={{
                  margin: "0",
                  fontSize: "18px",
                  fontWeight: "600",
                  color: "#1e293b"
                }}>
                  {editingItem ? 'Edit Expense Sub-Category' : 'Add Expense Sub-Category'}
                </h3>
                <div style={{
                  fontSize: "12px",
                  color: "#64748b",
                  marginTop: "2px"
                }}>
                  {editingItem ? 'Update sub-category details' : 'Enter sub-category details to create new expense sub-category'}
                </div>
              </div>
            </div>
            <button
              onClick={handleCloseForm}
              style={{
                backgroundColor: "transparent",
                border: "1px solid #e2e8f0",
                fontSize: "16px",
                cursor: "pointer",
                color: "#64748b",
                padding: "0",
                width: "32px",
                height: "32px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "6px",
                transition: "all 0.2s ease"
              }}
              onMouseOver={(e) => {
                e.target.style.backgroundColor = "#f1f5f9";
              }}
              onMouseOut={(e) => {
                e.target.style.backgroundColor = "transparent";
              }}
            >
              ×
            </button>
          </div>

          {/* Form Fields */}
          <div style={{
            display: "flex",
            flexDirection: "column",
            gap: "20px",
            marginBottom: "20px"
          }}>
            <div style={{
              display: "flex",
              alignItems: "center",
              gap: "20px"
            }}>
              <label style={{
                fontSize: "14px",
                fontWeight: "500",
                color: "#374151",
                minWidth: "180px",
                textAlign: "left"
              }}>
                Category <span style={{ color: "#ef4444" }}>*</span>
              </label>
              <div style={{ flex: 1 }}>
                <select
                  value={formData.category}
                  onChange={(e) => handleInputChange('category', e.target.value)}
                  style={{
                    width: "100%",
                    padding: "10px 12px",
                    border: errors.category ? "1px solid #ef4444" : "1px solid #d1d5db",
                    borderRadius: "6px",
                    fontSize: "14px",
                    outline: "none",
                    backgroundColor: "#ffffff",
                    color: "#1f2937",
                    transition: "all 0.2s ease",
                    boxSizing: "border-box"
                  }}
                  onFocus={(e) => {
                    e.target.style.borderColor = "#015c57";
                    e.target.style.boxShadow = "0 0 0 2px rgba(1,92,87,0.1)";
                  }}
                  onBlur={(e) => {
                    e.target.style.borderColor = errors.category ? "#ef4444" : "#d1d5db";
                    e.target.style.boxShadow = "none";
                  }}
                >
                  <option value="">Select category</option>
                  {categories.map((cat) => (
                    <option key={cat.categoryId} value={cat.categoryId}>
                      {cat.categoryName}
                    </option>
                  ))}
                </select>
                {errors.category && (
                  <div style={{
                    color: "#ef4444",
                    fontSize: "12px",
                    marginTop: "4px"
                  }}>
                    {errors.category}
                  </div>
                )}
              </div>
            </div>

            <div style={{
              display: "flex",
              alignItems: "center",
              gap: "20px"
            }}>
              <label style={{
                fontSize: "14px",
                fontWeight: "500",
                color: "#374151",
                minWidth: "180px",
                textAlign: "left"
              }}>
                Sub Category Name <span style={{ color: "#ef4444" }}>*</span>
              </label>
              <input
                type="text"
                value={formData.categoryName}
                onChange={(e) => handleInputChange('categoryName', e.target.value)}
                style={{
                  flex: 1,
                  padding: "10px 12px",
                  border: errors.categoryName ? "1px solid #ef4444" : "1px solid #d1d5db",
                  borderRadius: "6px",
                  fontSize: "14px",
                  outline: "none",
                  backgroundColor: "#ffffff",
                  color: "#1f2937",
                  transition: "all 0.2s ease",
                  boxSizing: "border-box"
                }}
                onFocus={(e) => {
                  e.target.style.borderColor = "#015c57";
                  e.target.style.boxShadow = "0 0 0 2px rgba(1,92,87,0.1)";
                }}
                onBlur={(e) => {
                  e.target.style.borderColor = errors.categoryName ? "#ef4444" : "#d1d5db";
                  e.target.style.boxShadow = "none";
                }}
                placeholder="Enter sub category name"
              />
              {errors.categoryName && (
                <div style={{
                  color: "#ef4444",
                  fontSize: "12px",
                  marginTop: "4px"
                }}>
                  {errors.categoryName}
                </div>
              )}
            </div>

            <div style={{
              display: "flex",
              alignItems: "center",
              gap: "20px"
            }}>
              <label style={{
                fontSize: "14px",
                fontWeight: "500",
                color: "#374151",
                minWidth: "180px",
                textAlign: "left"
              }}>
                Sub Category Type <span style={{ color: "#ef4444" }}>*</span>
              </label>
              <div style={{ flex: 1 }}>
                <input
                  type="text"
                  value={formData.categoryType}
                  onChange={(e) => handleInputChange('categoryType', e.target.value)}
                  style={{
                    width: "100%",
                    padding: "10px 12px",
                    border: errors.categoryType ? "1px solid #ef4444" : "1px solid #d1d5db",
                    borderRadius: "6px",
                    fontSize: "14px",
                    outline: "none",
                    backgroundColor: "#ffffff",
                    color: "#1f2937",
                    transition: "all 0.2s ease",
                    boxSizing: "border-box"
                  }}
                  onFocus={(e) => {
                    e.target.style.borderColor = "#015c57";
                    e.target.style.boxShadow = "0 0 0 2px rgba(1,92,87,0.1)";
                  }}
                  onBlur={(e) => {
                    e.target.style.borderColor = errors.categoryType ? "#ef4444" : "#d1d5db";
                    e.target.style.boxShadow = "none";
                  }}
                  placeholder="Enter sub-category type"
                />
                {errors.categoryType && (
                  <div style={{
                    color: "#ef4444",
                    fontSize: "12px",
                    marginTop: "4px"
                  }}>
                    {errors.categoryType}
                  </div>
                )}
              </div>
            </div>

            <div style={{
              display: "flex",
              alignItems: "flex-start",
              gap: "20px"
            }}>
              <label style={{
                fontSize: "14px",
                fontWeight: "500",
                color: "#374151",
                minWidth: "180px",
                textAlign: "left",
                paddingTop: "10px"
              }}>
                Category Sub Description <span style={{ color: "#ef4444" }}>*</span>
              </label>
              <div style={{ flex: 1 }}>
                <textarea
                  value={formData.categoryDescription}
                  onChange={(e) => handleInputChange('categoryDescription', e.target.value)}
                  style={{
                    width: "100%",
                    padding: "10px 12px",
                    border: errors.categoryDescription ? "1px solid #ef4444" : "1px solid #d1d5db",
                    borderRadius: "6px",
                    fontSize: "14px",
                    outline: "none",
                    backgroundColor: "#ffffff",
                    color: "#1f2937",
                    transition: "all 0.2s ease",
                    boxSizing: "border-box",
                    minHeight: "80px",
                    resize: "vertical"
                  }}
                  onFocus={(e) => {
                    e.target.style.borderColor = "#015c57";
                    e.target.style.boxShadow = "0 0 0 2px rgba(1,92,87,0.1)";
                  }}
                  onBlur={(e) => {
                    e.target.style.borderColor = errors.categoryDescription ? "#ef4444" : "#d1d5db";
                    e.target.style.boxShadow = "none";
                  }}
                  placeholder="Enter sub-category description"
                />
                {errors.categoryDescription && (
                  <div style={{
                    color: "#ef4444",
                    fontSize: "12px",
                    marginTop: "4px"
                  }}>
                    {errors.categoryDescription}
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Action Buttons */}
          <div style={{
            display: "flex",
            gap: "12px",
            justifyContent: "flex-end",
            paddingTop: "16px",
            borderTop: "1px solid #e2e8f0"
          }}>
            <button
              onClick={handleCloseForm}
              style={{
                padding: "8px 20px",
                background: "#ffffff",
                color: "#64748b",
                border: "1px solid #e2e8f0",
                borderRadius: "6px",
                fontSize: "14px",
                fontWeight: "500",
                cursor: "pointer",
                transition: "all 0.2s ease"
              }}
              onMouseOver={(e) => {
                e.target.style.background = "#f8fafc";
                e.target.style.borderColor = "#d1d5db";
              }}
              onMouseOut={(e) => {
                e.target.style.background = "#ffffff";
                e.target.style.borderColor = "#e2e8f0";
              }}
            >
              Cancel
            </button>
            <button
              onClick={handleSaveData}
              style={{
                padding: "8px 20px",
                background: "#015c57",
                color: "#ffffff",
                border: "none",
                borderRadius: "6px",
                fontSize: "14px",
                fontWeight: "500",
                cursor: "pointer",
                transition: "all 0.2s ease"
              }}
              onMouseOver={(e) => {
                e.target.style.background = "#0a7d75";
              }}
              onMouseOut={(e) => {
                e.target.style.background = "#015c57";
              }}
            >
              {editingItem ? 'Update Data' : 'Save Data'}
            </button>
          </div>
        </div>
      )}

      {/* List Sub-Categories */}
      {showList && (
        <div style={{
          backgroundColor: "#f8fafc",
          border: "1px solid #e2e8f0",
          borderRadius: "12px",
          padding: "24px",
          marginBottom: "32px",
          width: "100%",
          maxWidth: "1200px",
          margin: "0 auto 32px auto"
        }}>
          <div style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "20px",
            paddingBottom: "16px",
            borderBottom: "1px solid #e2e8f0"
          }}>
            <div style={{
              display: "flex",
              alignItems: "center",
              gap: "12px"
            }}>
              <div style={{
                width: "40px",
                height: "40px",
                borderRadius: "8px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "#015c57",
                color: "#ffffff"
              }}>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M16 5H3"/>
                  <path d="M16 12H3"/>
                  <path d="M11 19H3"/>
                  <path d="m15 18 2 2 4-4"/>
                </svg>
              </div>
              <div style={{ textAlign: "left" }}>
                <h3 style={{
                  margin: "0",
                  fontSize: "18px",
                  fontWeight: "600",
                  color: "#1e293b"
                }}>
                  Expense Sub-Categories
                </h3>
                <div style={{
                  fontSize: "12px",
                  color: "#64748b",
                  marginTop: "2px"
                }}>
                  Manage your expense sub-categories
                </div>
              </div>
            </div>
            <div style={{
              fontSize: "14px",
              color: "#64748b",
              fontWeight: "500"
            }}>
              {subcategories.length} sub-categories
            </div>
          </div>

          {subcategories.length === 0 ? (
            <div style={{
              textAlign: "center",
              padding: "40px",
              color: "#64748b"
            }}>
              <div style={{
                fontSize: "48px",
                color: "#e2e8f0",
                marginBottom: "16px"
              }}>
                📋
              </div>
              <div style={{
                fontSize: "16px",
                fontWeight: "600",
                marginBottom: "8px"
              }}>
                No sub-categories found
              </div>
              <div style={{
                fontSize: "14px"
              }}>
                Click ADD to create your first expense sub-category
              </div>
            </div>
          ) : (
            <div style={{
              backgroundColor: "#ffffff",
              border: "1px solid #e2e8f0",
              borderRadius: "8px",
              overflow: "hidden"
            }}>
              {/* Table Header */}
              <div style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr 2fr 120px",
                backgroundColor: "#f8fafc",
                borderBottom: "1px solid #e2e8f0"
              }}>
                <div style={{
                  padding: "12px 16px",
                  fontSize: "14px",
                  fontWeight: "600",
                  color: "#374151",
                  borderRight: "1px solid #e2e8f0"
                }}>
               Sub Category Name
                </div>
                <div style={{
                  padding: "12px 16px",
                  fontSize: "14px",
                  fontWeight: "600",
                  color: "#374151",
                  borderRight: "1px solid #e2e8f0"
                }}>
                 	Sub Category Type
                </div>
                <div style={{
                  padding: "12px 16px",
                  fontSize: "14px",
                  fontWeight: "600",
                  color: "#374151",
                  borderRight: "1px solid #e2e8f0"
                }}>
                  Sub Category Description
                </div>
                <div style={{
                  padding: "12px 16px",
                  fontSize: "14px",
                  fontWeight: "600",
                  color: "#374151",
                  textAlign: "center"
                }}>
                  Actions
                </div>
              </div>

              {/* Table Rows */}
              {subcategories.map((subcategory, index) => (
                <div key={subcategory.id} style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr 2fr 120px",
                  borderBottom: index < subcategories.length - 1 ? "1px solid #e2e8f0" : "none",
                  backgroundColor: "#ffffff",
                  transition: "all 0.2s ease"
                }}>
                  <div style={{
                    padding: "12px 16px",
                    fontSize: "14px",
                    color: "#1e293b",
                    borderRight: "1px solid #e2e8f0",
                    fontWeight: "500"
                  }}>
                    {subcategory.subCategoryName || 'Unnamed Sub-Category'}
                  </div>
                  <div style={{
                    padding: "12px 16px",
                    fontSize: "14px",
                    color: "#64748b",
                    borderRight: "1px solid #e2e8f0"
                  }}>
                    {subcategory.subCategoryType}
                  </div>
                  <div style={{
                    padding: "12px 16px",
                    fontSize: "13px",
                    color: "#64748b",
                    borderRight: "1px solid #e2e8f0"
                  }}>
                    {subcategory.subCategoryDescription}
                  </div>
                  <div style={{
                    padding: "12px 16px",
                    display: "flex",
                    gap: "6px",
                    justifyContent: "center",
                    alignItems: "center"
                  }}>
                    <div
                      onClick={() => handleEditClick(subcategory)}
                       style={{
                         padding: "4px 8px",
                         background: "#015c57",
                         color: "#ffffff",
                         border: "none",
                         borderRadius: "4px",
                         fontSize: "11px",
                         fontWeight: "500",
                         cursor: "pointer",
                         transition: "all 0.2s ease",
                         display: "flex",
                         alignItems: "center",
                         gap: "6px"
                       }}
                       onMouseOver={(e) => {
                         e.currentTarget.style.background = "#0a7d75";
                       }}
                       onMouseOut={(e) => {
                         e.currentTarget.style.background = "#015c57";
                       }}
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-square-pen-icon lucide-square-pen" style={{ width: "14px", height: "14px" }}>
                        <path d="M12 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
                        <path d="M18.375 2.625a1 1 0 0 1 3 3l-9.013 9.014a2 2 0 0 1-.853.505l-2.873.84a.5.5 0 0 1-.62-.62l.84-2.873a2 2 0 0 1 .506-.852z"/>
                      </svg>
                    </div>
                    <div
                      onClick={() => handleDeleteClick(subcategory.id)}
                       style={{
                         padding: "4px 8px",
                         background: "#6b7280",
                         color: "#ffffff",
                         border: "none",
                         borderRadius: "4px",
                         fontSize: "11px",
                         fontWeight: "500",
                         cursor: "pointer",
                         transition: "all 0.2s ease",
                         display: "flex",
                         alignItems: "center",
                         gap: "6px"
                       }}
                       onMouseOver={(e) => {
                         e.currentTarget.style.background = "#374151";
                       }}
                       onMouseOut={(e) => {
                         e.currentTarget.style.background = "#6b7280";
                       }}
                    >
                      <Trash2 size={14} />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      )}

</div>
  );
}

export default TAB2;